export const COOKIE_FUNCTIONAL = 'wtr_cookies_functional';
